module.exports = __webpack_public_path__ + "img/part.8ce5bb87.png";